export default __webpack_public_path__ + "a7a0dca.png";